"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = exports.LOADER_SIZES = void 0;
var react_1 = __importDefault(require("react"));
var theme_1 = require("../../../mantine-theme/src");
exports.LOADER_SIZES = {
    xs: 18,
    sm: 22,
    md: 36,
    lg: 44,
    xl: 58,
};
function Loader(_a) {
    var _b = _a.size, size = _b === void 0 ? 'md' : _b, color = _a.color, themeOverride = _a.themeOverride, others = __rest(_a, ["size", "color", "themeOverride"]);
    var theme = theme_1.useMantineTheme(themeOverride);
    return (react_1.default.createElement("svg", __assign({ width: theme_1.getSizeValue({ size: size, sizes: exports.LOADER_SIZES }) + "px", fill: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 6 }), viewBox: "0 0 135 140", xmlns: "http://www.w3.org/2000/svg", role: "presentation" }, others),
        react_1.default.createElement("rect", { y: "10", width: "15", height: "120", rx: "6" },
            react_1.default.createElement("animate", { attributeName: "height", begin: "0.5s", dur: "1s", values: "120;110;100;90;80;70;60;50;40;140;120", calcMode: "linear", repeatCount: "indefinite" }),
            react_1.default.createElement("animate", { attributeName: "y", begin: "0.5s", dur: "1s", values: "10;15;20;25;30;35;40;45;50;0;10", calcMode: "linear", repeatCount: "indefinite" })),
        react_1.default.createElement("rect", { x: "30", y: "10", width: "15", height: "120", rx: "6" },
            react_1.default.createElement("animate", { attributeName: "height", begin: "0.25s", dur: "1s", values: "120;110;100;90;80;70;60;50;40;140;120", calcMode: "linear", repeatCount: "indefinite" }),
            react_1.default.createElement("animate", { attributeName: "y", begin: "0.25s", dur: "1s", values: "10;15;20;25;30;35;40;45;50;0;10", calcMode: "linear", repeatCount: "indefinite" })),
        react_1.default.createElement("rect", { x: "60", width: "15", height: "140", rx: "6" },
            react_1.default.createElement("animate", { attributeName: "height", begin: "0s", dur: "1s", values: "120;110;100;90;80;70;60;50;40;140;120", calcMode: "linear", repeatCount: "indefinite" }),
            react_1.default.createElement("animate", { attributeName: "y", begin: "0s", dur: "1s", values: "10;15;20;25;30;35;40;45;50;0;10", calcMode: "linear", repeatCount: "indefinite" })),
        react_1.default.createElement("rect", { x: "90", y: "10", width: "15", height: "120", rx: "6" },
            react_1.default.createElement("animate", { attributeName: "height", begin: "0.25s", dur: "1s", values: "120;110;100;90;80;70;60;50;40;140;120", calcMode: "linear", repeatCount: "indefinite" }),
            react_1.default.createElement("animate", { attributeName: "y", begin: "0.25s", dur: "1s", values: "10;15;20;25;30;35;40;45;50;0;10", calcMode: "linear", repeatCount: "indefinite" })),
        react_1.default.createElement("rect", { x: "120", y: "10", width: "15", height: "120", rx: "6" },
            react_1.default.createElement("animate", { attributeName: "height", begin: "0.5s", dur: "1s", values: "120;110;100;90;80;70;60;50;40;140;120", calcMode: "linear", repeatCount: "indefinite" }),
            react_1.default.createElement("animate", { attributeName: "y", begin: "0.5s", dur: "1s", values: "10;15;20;25;30;35;40;45;50;0;10", calcMode: "linear", repeatCount: "indefinite" }))));
}
exports.Loader = Loader;
Loader.displayName = '@mantine/core/Loader';
